import JzSidebar from "../views/Upsell/modernTS/JUI/Sidebar/JzSidebar";
import SidebarLogo from "../views/Upsell/modernTS/JUI/Sidebar/SidebarLogo";
import { SidebarDivider } from "../views/Upsell/modernTS/JUI/Sidebar/SiderbarDivider";
import { UserProfileNavigationItem } from "../views/Upsell/modernTS/JUI/Sidebar/UserProfileNavigationItem";
import React, { useEffect, useRef } from "react";
import NavigationItem from "../views/Upsell/modernTS/JUI/Sidebar/NavigationItem";
import TranslationWrapper from "../components/TranslationWrapper/TranslationWrapper";
import NavigationGroup from "../views/Upsell/modernTS/JUI/Sidebar/NavigationGroup";
import {
  ArrowRight,
  BarChart,
  Book,
  Business,
  ConfirmationNumber,
  Dashboard,
  DateRange,
  Deck,
  Description,
  Event,
  Filter9Plus,
  FormatPaint,
  FreeBreakfast,
  Group,
  House,
  Https,
  Label,
  Link,
  LocalGroceryStore,
  LocalMall,
  MenuBook,
  Message,
  Money,
  Payment,
  People,
  Person,
  Print,
  RateReview,
  Receipt,
  Restaurant,
  RestaurantMenu,
  Schedule,
  ShoppingBasket,
  SupervisedUserCircle,
  Translate,
  VpnKey,
} from "@mui/icons-material";
import MonetizationOn from "@mui/icons-material/MonetizationOn";
import PerfectScrollbar from "perfect-scrollbar";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";

export function MainMenu({
  user,
}: {
  user: {
    username: string;
    isImpersonating: boolean;
  };
}) {
  const scrollRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1 && scrollRef.current) {
      const ps = new PerfectScrollbar(scrollRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      return () => {
        ps.destroy();
      };
    }
  }, []);
  return (
    <JzSidebar>
      <Stack
        sx={{
          display: "flex",
          flexDirection: "column",
          height: 1,
          overflow: "hidden",
        }}
      >
        <Box sx={{ px: 2, pt: 2 }}>
          <SidebarLogo />
          <SidebarDivider />
        </Box>
        <Stack
          gap={1}
          ref={scrollRef}
          sx={{ px: 2, pb: 2, height: 0, flex: "1 1 0%", position: "relative", overflowY: "auto" }}
        >
          <UserProfileNavigationItem user={user} />
          <SidebarDivider />
          <>
            <NavigationItem
              auth={"sidebar.tabs./knowledge"}
              icon={<Book sx={{ color: "#fff" }} />}
              style={{
                backgroundColor: "#253171",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                borderRadius: "3px",
              }}
              target={"_blank"}
              text={<TranslationWrapper tDefault={"Kennisbank"} tKey={"menu.items.kennisbank"} />}
              to={"https://knowledge.jamezz.com/knowledge"}
            />
            <NavigationItem
              auth={"sidebar.tabs./dashboard"}
              icon={<Dashboard />}
              text={<TranslationWrapper tDefault={"Dashboard"} tKey={"menu.items.dashboard"} />}
              to={"/manager/dashboard"}
            />
            <NavigationItem
              auth={"sidebar.tabs./rapportages"}
              icon={<BarChart />}
              text={<TranslationWrapper tDefault={"Rapportages"} tKey={"menu.items.rapportages"} />}
              to={"/manager/rapportages"}
            />
            <NavigationItem
              auth={"sidebar.tabs./bi"}
              icon={<BarChart />}
              text={<TranslationWrapper tDefault={"BI"} tKey={"menu.items.bi"} />}
              to={"/manager/bi"}
            />
            <NavigationItem
              auth={"sidebar.tabs./venues"}
              icon={<House />}
              text={<TranslationWrapper tDefault={"Venues"} tKey={"menu.items.venues"} />}
              to={"/manager/venues"}
            />
            <NavigationItem
              auth={"sidebar.tabs./vestigingen"}
              icon={<Restaurant />}
              text={<TranslationWrapper tDefault={"Verkoopgebieden"} tKey={"menu.items.verkoopgebieden"} />}
              to={"/manager/vestigingen"}
            />
            <NavigationGroup
              auth={"sidebar.tabs.Menubuilding"}
              icon={<MenuBook />}
              text={<TranslationWrapper tDefault={"Menu building"} tKey={"menu.items.menubuilding"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./kaarten"}
                icon={<RestaurantMenu />}
                text={<TranslationWrapper tDefault={"Menukaarten"} tKey={"menu.items.menukaarten"} />}
                to={"/manager/kaarten"}
              />
              <NavigationItem
                auth={"sidebar.tabs./producten"}
                icon={<FreeBreakfast />}
                text={<TranslationWrapper tDefault={"Producten"} tKey={"menu.items.producten"} />}
                to={"/manager/producten"}
              />
              <NavigationItem
                auth={"sidebar.tabs./optionGroups"}
                icon={<FreeBreakfast />}
                text={<TranslationWrapper tDefault={"Option groups"} tKey={"menu.items.optionGroups"} />}
                to={"/manager/optionGroups"}
              />
              <NavigationItem
                auth={"sidebar.tabs./upsell"}
                icon={<MonetizationOn />}
                text={<TranslationWrapper tDefault={"Upsell (Alpha)"} tKey={"menu.items.upsell"} />}
                to={"/manager/upsell"}
              />
              <NavigationItem
                auth={"sidebar.tabs./tags"}
                icon={<Label />}
                text={<TranslationWrapper tDefault={"Tags"} tKey={"menu.items.tags"} />}
                to={"/manager/tags"}
              />
              <NavigationItem
                auth={"sidebar.tabs./campaigns"}
                icon={<LocalGroceryStore />}
                text={<TranslationWrapper tDefault={"Campaigns"} tKey={"menu.items.campaigns"} />}
                to={"/manager/campaigns"}
              />
              <NavigationItem
                auth={"sidebar.tabs./price-lines"}
                icon={<MonetizationOn />}
                text={<TranslationWrapper tDefault={"Price lines"} tKey={"menu.items.price-lines"} />}
                to={"/manager/price-lines"}
              />
            </NavigationGroup>
            <NavigationItem
              auth={"sidebar.tabs./timeschedules"}
              icon={<DateRange />}
              text={<TranslationWrapper tDefault={"Time schedules"} tKey={"menu.items.timeschedules"} />}
              to={"/manager/timeschedules"}
            />
            <NavigationGroup
              auth={"sidebar.tabs.arrangements"}
              icon={<Translate />}
              text={<TranslationWrapper tDefault={"Arrangements"} tKey={"menu.items.arrangements"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./arrangement-groups"}
                icon={<Translate />}
                text={
                  <TranslationWrapper
                    tDefault={"Arrangement Groups"}
                    tKey={"menu.items.arrangements.arrangement-groups"}
                  />
                }
                to={"/manager/arrangement-groups"}
              />
              <NavigationItem
                auth={"sidebar.tabs./arrangements"}
                icon={<Translate />}
                text={<TranslationWrapper tDefault={"Arrangements"} tKey={"menu.items.arrangements.arrangements"} />}
                to={"/manager/arrangements"}
              />
            </NavigationGroup>
            <NavigationGroup
              auth={"sidebar.tabs.packaging"}
              icon={<LocalMall />}
              text={<TranslationWrapper tDefault={"Packaging"} tKey={"menu.items.packaging"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./packaging-types"}
                text={<TranslationWrapper tDefault={"Packaging Types"} tKey={"menu.items.packaging.packaging-types"} />}
                to={"/manager/packaging-types"}
              />
              <NavigationItem
                auth={"sidebar.tabs./packagings"}
                text={<TranslationWrapper tDefault={"Packagings"} tKey={"menu.items.packaging.packagings"} />}
                to={"/manager/packagings"}
              />
            </NavigationGroup>
            <NavigationItem
              auth={"sidebar.tabs./tafels"}
              icon={<Deck />}
              text={<TranslationWrapper tDefault={"Tafels"} tKey={"menu.items.tafels"} />}
              to={"/manager/tafels"}
            />
            <NavigationItem
              auth={"sidebar.tabs./zones"}
              icon={<Filter9Plus />}
              text={<TranslationWrapper tDefault={"Zones"} tKey={"menu.items.zones"} />}
              to={"/manager/zones"}
            />
            <NavigationItem
              auth={"sidebar.tabs./reviews"}
              icon={<RateReview />}
              text={<TranslationWrapper tDefault={"Reviews"} tKey={"menu.items.reviews"} />}
              to={"/manager/reviews"}
            />
            <NavigationItem
              auth={"sidebar.tabs./preordering"}
              icon={<Event />}
              text={<TranslationWrapper tDefault={"Pre ordering"} tKey={"menu.items.preOrdering"} />}
              to={"/manager/preordering"}
            />
            <NavigationItem
              auth={"sidebar.tabs./bestellingen"}
              icon={<ShoppingBasket />}
              text={<TranslationWrapper tDefault={"Bestellingen"} tKey={"menu.items.bestellingen"} />}
              to={"/manager/bestellingen"}
            />
            <NavigationItem
              auth={"sidebar.tabs./payments"}
              icon={<Money />}
              text={<TranslationWrapper tDefault={"Payments / Vouchers"} tKey={"menu.items.payments_vouchers"} />}
              to={"/manager/payments"}
            />
            <NavigationGroup
              auth={"sidebar.tabs.vouchers"}
              icon={<ConfirmationNumber />}
              text={<TranslationWrapper tDefault={"Kortingscodes"} tKey={"menu.items.voucherMenu"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./voucherDefs"}
                text={<TranslationWrapper tDefault={"VoucherDefs"} tKey={"menu.items.voucherDefs"} />}
                to={"/manager/voucherDefs"}
              />
              <NavigationItem
                auth={"sidebar.tabs./vouchers"}
                text={<TranslationWrapper tDefault={"Vouchers"} tKey={"menu.items.vouchers"} />}
                to={"/manager/vouchers"}
              />
            </NavigationGroup>
            <NavigationGroup
              auth={"sidebar.tabs.translations"}
              icon={<Translate />}
              text={<TranslationWrapper tDefault={"Translations"} tKey={"menu.items.translations"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./transedit"}
                icon={<Translate />}
                text={<TranslationWrapper tDefault={"Translations"} tKey={"menu.items.transedit"} />}
                to={"/manager/transedit"}
              />
              <NavigationItem
                auth={"sidebar.tabs./backoffice-translations"}
                icon={<Business />}
                text={<TranslationWrapper tDefault={"Backoffice"} tKey={"menu.items.translations.backoffice"} />}
                to={"/manager/backoffice-translations"}
              />
            </NavigationGroup>
            <NavigationItem
              auth={"sidebar.tabs./printers"}
              icon={<Print />}
              text={<TranslationWrapper tDefault={"Printers"} tKey={"menu.items.printers"} />}
              to={"/manager/printers"}
            />
            <NavigationItem
              auth={"sidebar.tabs./printerqueue"}
              icon={<Print />}
              text={<TranslationWrapper tDefault={"Printers queue"} tKey={"menu.items.printersqueue"} />}
              to={"/manager/printerqueue"}
            />
            <NavigationItem
              auth={"sidebar.tabs./shortlinks"}
              icon={<Link />}
              text={<TranslationWrapper tDefault={"Shortlinks"} tKey={"menu.items.shortlinks"} />}
              to={"/manager/shortlinks"}
            />
            <NavigationItem
              auth={"sidebar.tabs./notifications"}
              icon={<Message />}
              text={<TranslationWrapper tDefault={"Berichten"} tKey={"menu.items.notifications"} />}
              to={"/manager/notifications"}
            />
            <NavigationItem
              auth={"sidebar.tabs./gebruikers"}
              icon={<Group />}
              text={<TranslationWrapper tDefault={"Gebruikers"} tKey={"menu.items.gebruikers"} />}
              to={"/manager/gebruikers"}
            />
            <NavigationGroup
              auth={"sidebar.tabs.permissions"}
              icon={<VpnKey />}
              text={<TranslationWrapper tDefault={"Permissions"} tKey={"menu.items.permissions"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./profiles"}
                icon={<Person />}
                text={<TranslationWrapper tDefault={"Profiles"} tKey={"menu.items.profile"} />}
                to={"/manager/profiles"}
              />
              <NavigationItem
                auth={"sidebar.tabs./roles"}
                icon={<FormatPaint />}
                text={<TranslationWrapper tDefault={"Roles"} tKey={"menu.items.role"} />}
                to={"/manager/roles"}
              />
              <NavigationItem
                auth={"sidebar.tabs./permissions"}
                icon={<Https />}
                text={<TranslationWrapper tDefault={"Permissions"} tKey={"menu.items.permission"} />}
                to={"/manager/permissions"}
              />
            </NavigationGroup>
            <NavigationItem
              auth={"sidebar.tabs./relations"}
              icon={<Business />}
              text={<TranslationWrapper tDefault={"Relaties"} tKey={"menu.items.relations"} />}
              to={"/manager/relations"}
            />
            <NavigationGroup
              auth={"sidebar.tabs.logs.main"}
              icon={<Description />}
              text={<TranslationWrapper tDefault={"Tools"} tKey={"menu.items.logs"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./apilog"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Api"} tKey={"menu.items.apilog"} />}
                to={"/manager/apilog"}
              />
              <NavigationItem
                auth={"sidebar.tabs./servicelog"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Service logs"} tKey={"menu.items.servicelog"} />}
                to={"/manager/servicelog"}
              />
              <NavigationItem
                auth={"sidebar.tabs./smslog"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Sms"} tKey={"menu.items.sms"} />}
                to={"/manager/smslog"}
              />
              <NavigationItem
                auth={"sidebar.tabs./callbacklog"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Callback"} tKey={"menu.items.logs.callbacklog"} />}
                to={"/manager/callbacklog"}
              />
              <NavigationItem
                auth={"sidebar.tabs./gateways"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Gateways"} tKey={"menu.items.gateways"} />}
                to={"/manager/gateways"}
              />
              <NavigationItem
                auth={"sidebar.tabs./scheduledTasks"}
                icon={<Schedule />}
                text={<TranslationWrapper tDefault={"Scheduled Tasks"} tKey={"menu.items.scheduledTasks"} />}
                to={"/manager/scheduledTasks"}
              />
            </NavigationGroup>
            <NavigationGroup
              auth={"sidebar.tabs.licensing.main"}
              icon={<Payment />}
              text={<TranslationWrapper tDefault={"Licensing"} tKey={"menu.items.subscriptions"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./subsdashboard"}
                icon={<BarChart />}
                text={<TranslationWrapper tDefault={"TODO"} tKey={"Dashboard"} />}
                to={"/manager/subsdashboard"}
              />
              <NavigationItem
                auth={"sidebar.tabs./subssubscriptions"}
                icon={<Payment />}
                text={<TranslationWrapper tDefault={"Licenses"} tKey={"licenses"} />}
                to={"/manager/subssubscriptions"}
              />
              <NavigationItem
                auth={"sidebar.tabs./subsdebtors"}
                icon={<Payment />}
                text={<TranslationWrapper tDefault={"Debtors"} tKey={"Debtors"} />}
                to={"/manager/subsdebtors"}
              />
              <NavigationItem
                auth={"sidebar.tabs./subsinvoices"}
                icon={<Receipt />}
                text={<TranslationWrapper tDefault={"Invoices"} tKey={"Invoices"} />}
                to={"/manager/subsinvoices"}
              />
              <NavigationItem
                auth={"sidebar.tabs./subspriceplans"}
                icon={<Schedule />}
                text={<TranslationWrapper tDefault={"Price Plans"} tKey={"Price Plans"} />}
                to={"/manager/subspriceplans"}
              />
              <NavigationItem
                auth={"sidebar.tabs./subsresellers"}
                icon={<People />}
                text={<TranslationWrapper tDefault={"Resellers"} tKey={"Resellers"} />}
                to={"/manager/subsresellers"}
              />
            </NavigationGroup>
            <NavigationGroup
              auth={"sidebar.tabs.admintools.main"}
              icon={<SupervisedUserCircle />}
              text={<TranslationWrapper tDefault={"Admin"} tKey={"menu.items.admin"} />}
            >
              <NavigationItem
                auth={"sidebar.tabs./resexp"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Resellers export"} tKey={"menu.items.resexp"} />}
                to={"/manager/resexp"}
              />
              <NavigationItem
                auth={"sidebar.tabs./checkpayment"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Betaling status"} tKey={"menu.items.payment check"} />}
                to={"/manager/checkpayment"}
              />
              <NavigationItem
                auth={"sidebar.tabs./importexport"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Import / Export"} tKey={"menu.items.import-export"} />}
                to={"/manager/importexport"}
              />
              <NavigationItem
                auth={"sidebar.tabs./defaultsettings"}
                icon={<ArrowRight />}
                text={<TranslationWrapper tDefault={"Default settings"} tKey={"menu.items.defaultsettings"} />}
                to={"/manager/defaultsettings"}
              />
            </NavigationGroup>
            <NavigationItem
              auth={"sidebar.tabs./articleTraitValues"}
              icon={<Group />}
              text={<TranslationWrapper tDefault={"articleTraitValues"} tKey={"menu.items.articleTraitValues"} />}
              to={"/manager/articleTraitValues"}
            />
            <NavigationItem
              auth={"sidebar.tabs./articleTraits"}
              icon={<Group />}
              text={<TranslationWrapper tDefault={"articleTraits"} tKey={"menu.items.articleTraits"} />}
              to={"/manager/articleTraits"}
            />
          </>
        </Stack>
      </Stack>
    </JzSidebar>
  );
}
